import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { VariableUser } from './VariableUser';
import { putUser } from '../../store/Actions/ActionUser';
import '../../assets/styles/StylePopup.css'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang';
import { Form } from '../../components/general/general-component/abstruct-component/AbstructForm';

function EditUser({ arr, open, setOpen }) {
    let { mode, dispatch, langLocal } = AbstructVar()
    const { translate } = AbstructLang()
    const { state, setStateCustom, setLoad, setState } = VariableUser()
    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            name: arr.name,
            email: arr.email,
            role: arr.role
        }));
    }, [])
    const Submit = e => {
        e.preventDefault()
        console.log(arr)
        dispatch(putUser(arr.id, state.name, state.email, state.password, state.role, setLoad))
    }
    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
        { name: "email", label: "email", type: "text", inputType: 'text', iconType: "envelope" },
        { name: "password", label: "password", type: "text", inputType: 'text', iconType: "key" },
        {
            name: "role", label: "Roles", type: "text", inputType: 'one_select', iconType: "role",
            options: [
                { value: "manager", label: "manager" },
                { value: "reader", label: "reader" },
                { value: "accountant", label: "accountant" },
                { value: "accounting-manager", label: "accounting-manager" },
            ],
            defaultvaluee: { value: state.role, label: state.role }
        },
    ];
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `popupR`,
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`}>
                <div className={`div_title_popup ${mode === 'dark' ? "darktoppopup" : "lighttoppopup"}`}  >
                    <p className={`title_popup ${mode === 'dark' ? "darktext" : "lighttext"}`} >{translate('edit_user')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={Submit} state={state} setStateCustom={setStateCustom} translate={translate} buttonLabel="edit" />
            </div>
        </RModal>
    )
}

export default EditUser